import { render } from "./VonageLoader.vue?vue&type=template&id=00a3da99&scoped=true"
import script from "./VonageLoader.vue?vue&type=script&lang=js"
export * from "./VonageLoader.vue?vue&type=script&lang=js"

import "./VonageLoader.vue?vue&type=style&index=0&id=00a3da99&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00a3da99"]])

export default __exports__